import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
export function RealEstatePage() {
  const properties = [{
    name: 'The Downtown Plaza',
    type: 'Mixed Use / Flagship',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80'
  }, {
    name: 'Westside Market',
    type: 'Retail / Food Hall',
    image: 'https://images.unsplash.com/photo-1519999482648-25049ddd37b1?w=800&q=80'
  }, {
    name: 'North Hills Estate',
    type: 'Event Venue',
    image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800&q=80'
  }];
  return <div className="bg-white" data-id="element-371">
      <PageHero title="Real Estate" subtitle="Acquisition and development of prime hospitality real estate." backgroundImage="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80" data-id="element-372" />

      <section className="py-24 md:py-32" data-id="element-373">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-374">
          <div className="text-center mb-20" data-id="element-375">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-376">
              Owned & Operated Properties
            </h2>
            <div className="w-16 h-1 bg-brand-terracotta mx-auto" data-id="element-377"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-32" data-id="element-378">
            {properties.map((prop, idx) => <motion.div key={idx} className="group relative overflow-hidden rounded-sm aspect-[4/5]" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-379">
                <img src={prop.image} alt={prop.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-380" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/90 via-brand-dark/20 to-transparent" data-id="element-381"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-382">
                  <p className="text-brand-gold text-xs uppercase tracking-widest mb-2" data-id="element-383">
                    {prop.type}
                  </p>
                  <h3 className="text-2xl font-serif text-white" data-id="element-384">
                    {prop.name}
                  </h3>
                </div>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-385">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-386">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-dark mb-6" data-id="element-387">
                Partnership Opportunities
              </h2>
              <div className="w-12 h-1 bg-brand-red mb-8" data-id="element-388"></div>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-6" data-id="element-389">
                We actively seek partnerships with landlords, developers, and
                brokers to anchor new developments with our proven hospitality
                concepts.
              </p>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed" data-id="element-390">
                Our presence consistently drives foot traffic, elevates property
                prestige, and increases surrounding asset values.
              </p>
            </motion.div>

            <motion.div className="bg-brand-gray/10 p-10 rounded-sm" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-391">
              <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-392">
                Real Estate Contact
              </h3>
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-393">
                <div data-id="element-394">
                  <input type="text" placeholder="Name / Company" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors" data-id="element-395" />
                </div>
                <div data-id="element-396">
                  <input type="email" placeholder="Email Address" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors" data-id="element-397" />
                </div>
                <div data-id="element-398">
                  <textarea rows={3} placeholder="Property Details / Proposal" className="w-full bg-transparent border-b border-brand-dark/20 py-2 focus:outline-none focus:border-brand-red transition-colors resize-none" data-id="element-399"></textarea>
                </div>
                <button className="bg-brand-dark text-white px-8 py-3 text-sm uppercase tracking-[0.2em] hover:bg-brand-red transition-colors" data-id="element-400">
                  Submit Proposal
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}